import { IDeductionDisputeRepository } from "@/core/repositories/deduction";
import { GetDisputeConfigDTO } from "@/core/dto/deduction/disputeDeduction";

export class GetDisputeConfigUseCase {
  constructor(private readonly disputeRepository: IDeductionDisputeRepository) {}

  async execute(params: GetDisputeConfigDTO) {
    const response = await this.disputeRepository.getDisputeConfig(params);
    return response;
  }
}